export default "__VITE_ASSET__78b39763__"